import React from 'react';
import './style.scss'

import AssociateHeader from '../../Associate/componets/AssociateHeader'

import Menu from '../../components/Menu'
import Footer from '../../components/Footer'


function Associate() {   
  return (
       <>       
        <Menu></Menu>
        <div className="pag-associate">
          <AssociateHeader/>
        </div>        
        <Footer></Footer>
      </>
  );
}

export default Associate;